import { useEffect, useMemo, useState } from "react";
import { usePwaContext } from "../context/pwa-context";
import { useTranslation } from "react-i18next";

export default function useGetApp() {
  const { t } = useTranslation("common");
  const { doesRelatedAppExist } = usePwaContext();
  const [appExists, setAppExists] = useState<boolean | undefined>(false);

  const ctaText = useMemo(() => {
    if (appExists || appExists === undefined) return t("use");
    return t("get");
  }, [t, appExists]);

  useEffect(() => {
    (async () => {
      const appFound = await doesRelatedAppExist();
      setAppExists(appFound);
    })();
  }, [doesRelatedAppExist]);

  return { ctaText, appExists };
}
